<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-27 17:45:58
 * @LastEditors: Please set LastEditors
 -->
<template>
  <!-- 出货统计组件 -->
  <div>
    <div class="pageTitle secondTitle">
      经销商呆滞品统计(客户所有的产品从入库日期到查询当天的时间，大于{{
        time
      }}天(天数可由后台自动<router-link
        tag="span"
        to="basicSetting"
        style="color:rgb(35, 169, 242)"
        >设置</router-link
      >）未销售出去的，定义为作为“呆滞品”；统计数据非实时统计，更新截止前一天)
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="呆滞品统计(经销商)" name="1">
        <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
          <!-- <el-form-item label="失效时间" style="text-align: center"> -->
          <!-- <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form1.start"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form1.end"
                                    style="width: 100%;"></el-date-picker> -->
          <!-- </el-col> -->
          <!-- </el-form-item> -->

          <dealerLeve @leves="getLeve"> </dealerLeve>
          <el-form-item label="生产批次号:" v-if="is_show == 1">
            <el-input v-model="form1.production_batch" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编号:">
            <el-input v-model="form1.product_sn" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称:">
            <el-input v-model="form1.product_name" clearable></el-input>
          </el-form-item>

          <el-form-item label="经销商:">
            <el-col :span="12">
              <el-input v-model="form1.to_sn" clearable></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 10px;">
              <el-button
                type="primary"
                @click="selectDealerDialog = !selectDealerDialog"
                >选择</el-button
              >
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch()">搜索</el-button>
            <el-button type="primary" @click="onExport()">导出</el-button>
          </el-form-item>
        </el-form>

        <el-table
          ref="multipleTable"
          :data="tableData1"
          v-loading="loading"
          height="300"
          border
          stripe
          style="margin: 20px 0;width:95%"
        >
          <el-table-column prop="dealer_sn" label="序号" width="70px" fixed>
            <template slot-scope="scope">
              {{ scope.$index }}
            </template>
          </el-table-column>
          <el-table-column
            prop="to_name"
            label="经销商名称"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="to_sn"
            label="经销商编号"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="to_level_name"
            label="经销商级别"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="dead_stock_num"
            label="呆滞数量"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="" label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)"
                >明细</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo1"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize1"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="呆滞品统计(产品)" name="2">
        <el-form ref="form2" :model="form2" label-width="120px" :inline="true">
          <!-- <el-form-item label="出库时间" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form2.start"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form2.end"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item> -->

          <dealerLeve @leves="getLeve"> </dealerLeve>
          <el-form-item label="生产批次号:" v-if="is_show == 1">
            <el-input v-model="form2.production_batch" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编号:">
            <el-input v-model="form2.product_sn" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称:">
            <el-input v-model="form2.product_name" clearable></el-input>
          </el-form-item>

          <el-form-item label="经销商:">
            <el-col :span="12">
              <el-input v-model="form2.to_sn" clearable></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 10px;">
              <el-button
                type="primary"
                @click="selectDealerDialog = !selectDealerDialog"
                >选择</el-button
              >
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch()">搜索</el-button>
            <el-button type="primary" @click="onExport()">导出</el-button>
          </el-form-item>
        </el-form>

        <el-table
          ref="multipleTable"
          :data="tableData2"
          v-loading="loading"
          height="300"
          border
          stripe
          style="margin: 20px 0;width:95%"
        >
          <el-table-column prop="dealer_sn" label="序号" width="100" fixed>
            <template slot-scope="scope">
              {{ scope.$index }}
            </template>
          </el-table-column>
          <el-table-column
            prop="product_sn"
            label="产品编号"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="product_name"
            label="产品名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="product_specs"
            label="规格"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="dead_stock_num"
            label="呆滞数量"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="" label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)"
                >明细</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageNo2"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize2"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <!--选择经销商-->
    <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    >
    </selectDealer>
    <el-dialog title="明细" :visible.sync="DetailDialog" width="80%">
      <el-button type="primary" @click="exproDetail" style="margin-bottom:10px"
        >导出</el-button
      >
      <el-table
        ref="multipleTable"
        :data="tableData3"
        v-loading="loading"
        border
        stripe
      >
        <el-table-column
          prop="production_batch"
          label="生产批次号"
          fixed
          v-if="is_show == 1"
        >
        </el-table-column>
        <el-table-column
          prop="to_sn"
          label="所属经销商编号"
          fixed
          v-if="activeName == 2"
        >
        </el-table-column>
        <el-table-column
          prop="to_name"
          label="所属经销商名称"
          v-if="activeName == 2"
        >
        </el-table-column>
        <el-table-column
          prop="to_level_name"
          label="所属经销商级别"
          v-if="activeName == 2"
        >
        </el-table-column>
        <el-table-column
          prop="product_sn"
          label="产品编号"
          fixed
          v-if="activeName == 1"
        >
        </el-table-column>
        <el-table-column
          prop="product_name"
          label="产品名称"
          v-if="activeName == 1"
        >
        </el-table-column>
        <el-table-column
          prop="product_specs"
          label="产品规格"
          v-if="activeName == 1"
        >
        </el-table-column>
        <el-table-column
          prop="production_date"
          label="生产日期"
          fixed="right"
          v-if="is_show == 1"
        >
        </el-table-column>
        <el-table-column
          prop="expiring_date"
          label="有效期至"
          fixed="right"
          v-if="is_show == 1"
        >
        </el-table-column>
        <el-table-column prop="dead_stock_num" label="呆滞品数量">
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 20px 0"
        @size-change="handleSizeChange3"
        @current-change="handleCurrentChange3"
        :current-page="pageNo3"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pageSize3"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize3"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="(DetailDialog = false), (pageSize3 = 10), (pageNo3 = 1)"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="(DetailDialog = false), (pageSize3 = 10), (pageNo3 = 1)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import selectDealer from "../../../common/selectDealer";
import dealerLeve from "../../../common/dealerLeve";
export default {
  name: "sluggish",
  data() {
    return {
      selectDealerDialog: false,
      activeName: "1",
      loading: false,
      form1: {
        product_sn: "",
        product_name: "",
        role: "",
        isgift: "",
        start_time: "",
        end_time: "",
        to_sn: "",
      },
      form2: {},
      tableData1: [],
      tableData2: [],
      pageNo1: 1,
      pageSize1: 20,
      totalSize1: 0,
      pageNo2: 1,
      pageSize2: 10,
      totalSize2: 0,
      detailData: {},
      pageNo3: 1,
      pageSize3: 10,
      totalSize3: 0,
      tableData3: [],
      is_show: 1,
      DetailDialog: false,
    };
  },
  methods: {
    // 获取经销商等级
    getLeve(value) {
      if (this.activeName == 1) {
        this.form1.to_level_id = value;
      } else {
        this.form2.to_level_id = value;
      }
    },
    getConfig() {
      this.$get("logistics", "/configs").then((res) => {
        this.is_show = res.data.production_batch_on_off;
        this.time = res.data.dead_stock;
      });
    },
    // 导出
    onExport() {
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");

      if (this.activeName == 1) {
        window.open(
          this.$Base_Export +
            "/dealers.deadstocks.export?" +
            "&to_level_id=" +
            this.form1.to_level_id +
            "&to_sn=" +
            this.form1.to_sn +
            "&start_time=" +
            "&end_time=" +
            "&product_name=" +
            this.form1.product_name +
            "&product_sn=" +
            this.form1.product_sn +
            "&production_batch=" +
            this.form1.production_batch +
            "&lang=" +
            "" +
            "&is_export=1" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else {
        window.open(
          url +
            process.env.VUE_APP_URL +
            "/dealers.deadstocks.products.export?" +
            "&to_sn=" +
            this.form2.to_sn +
            "&to_level_id=" +
            this.form2.to_level_id +
            "&start_time=" +
            "&end_time=" +
            "&product_name=" +
            this.form2.product_name +
            "&product_sn=" +
            this.form2.product_sn +
            "&production_batch=" +
            this.form2.production_batch +
            "&lang=" +
            "" +
            "&is_export=1" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    onSearch() {
      this.loading = true;
      if (this.activeName == 1) {
        this.$get("logistics", "/dealers.deadstocks", {
          ...this.form1,
          per_page: this.pageSize1,
          page: this.pageNo1,
        }).then((res) => {
          this.tableData1 = res.data;
          this.loading = false;
          this.totalSize1 = res.meta.total;
        });
      } else {
        this.$get("logistics", "/dealers.deadstocks.products", {
          ...this.form2,
          per_page: this.pageSize2,
          page: this.pageNo2,
        }).then((res) => {
          this.tableData2 = res.data;
          this.loading = false;
          this.totalSize2 = res.meta.total;
        });
      }
    },
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    detail(data) {
      this.tableData3 = [];
      this.loading = true;
      this.DetailDialog = true;
      if (data) {
        this.detailData = data;
      }
      if (this.activeName == 1) {
        this.$get("logistics", "/dealers.deadstocks/datas", {
          to_sn: this.detailData.to_sn,
        }).then((res) => {
          this.tableData3 = res.data;
          this.loading = false;
          this.totalSize3 = res.meta.total;
        });
      } else {
        this.$get("logistics", "/dealers.deadstocks.products/datas", {
          product_sn: this.detailData.product_sn,
        }).then((res) => {
          this.tableData3 = res.data;
          this.loading = false;
          this.totalSize3 = res.meta.total;
        });
      }
    },
    getSelectinfo(val) {
      if (this.activeName == 1) {
        this.form1.to_sn = val.dealer_sn;
      } else {
        this.form2.to_sn = val.dealer_sn;
      }
    },
    // 导出详情
    exproDetail() {
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");

      if (this.activeName == 1) {
        window.open(
          this.$Base_Export +
            "/dealers.deadstocks/datas.export?to_sn=" +
            this.detailData.to_sn +
            "&lang=" +
            "" +
            "&is_export=1" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      } else {
        window.open(
          this.$Base_Export +
            "/dealers.deadstocks.products​/datas.export?" +
            "product_sn=" +
            this.detailData.product_sn +
            "&lang=" +
            "" +
            "&is_export=1" +
            "&signature=" +
            this.$md5(access_tokens)
        );
      }
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.onSearch();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;

      this.onSearch();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.onSearch();
    },
    handleCurrentChange2(val) {
      this.pageNo2 = val;

      this.onSearch();
    },
    handleClick() {
      this.onSearch();
    },
    handleSizeChange3(val) {
      this.pageSize3 = val;
      this.detail();
    },
    handleCurrentChange3(val) {
      this.pageNo3 = val;

      this.detail();
    },
  },

  created() {
    this.form1.start = this.getLastMonth().last;
    this.form1.end = this.getLastMonth().now;
    this.form2.start = this.getLastMonth().last;
    this.form2.end = this.getLastMonth().now;
    this.onSearch();
    this.getConfig();
  },
  components: {
    selectDealer,
    dealerLeve,
  },
};
</script>
